<div mat-dialog-content>
  <p>Would you like to save the questionnaire before leaving the page?</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="'discard'" cdkFocusInitial>Discard</button>
  <button mat-button [mat-dialog-close]="'save'" cdkFocusInitial>Save</button>
</div>



// WEBPACK FOOTER //
// ./src/app/sdg/save-discard-dialog/save-discard-dialog.component.html